import { copy } from "./shared";
import ThankYouBody from "./ThankYouBody";
import "../templates/Template12.css";
import "./CheckoutTemplate12.css";

/*
   Checkout Template 12 — a seamless continuation of sales Template 12
   ("Vibrant Gradient Mesh"). Reuses Template12.css directly (same .clp12-root
   design system): the real frosted-glass .gm12-nav, the light gradient-mesh
   .gm12-hero band with its .gm12-title, the glossy .gm12-btn.gm12-btn-p button
   and the dark .gm12-foot footer. Only the form + order-summary cards are
   checkout-specific (CheckoutTemplate12.css), styled as the template's
   frosted-glass cards so the whole page reads as one site.
*/
export default function ThankYouTemplate12({ data = {} }) {
  const c = copy(data);

  return (
    <div className="clp12-root">
      {/* NAV — same frosted-glass bar as the sales page (solid `.scr` look) */}
      <nav className="gm12-nav scr">
        <div className="gm12-wrap gm12-nav-in">
          <span className="gm12-logo">
            {c.logo ? <img src={c.logo} alt="" /> : <span className="cok12-brandtext">{c.brand}</span>}
          </span>
          <span className="cok12-secure">✓ Order confirmed</span>
        </div>
      </nav>

      {/* HERO — reuses the sales gradient-mesh band + .gm12-title */}
      <header className="gm12-hero cok12-hero">
        <div className="gm12-wrap">
          <div className="cok12-hero-in">
            <span className="cok12-eyebrow">Thank you</span>
            <h1 className="gm12-title">
              You're <span className="cok12-accent">enrolled</span>
            </h1>
            {c.sub ? <p className="gm12-sub cok12-sub">{c.sub}</p> : null}
          </div>
        </div>
      </header>

      {/* FORM + ORDER SUMMARY — in the template's frosted-glass card style */}
      <div className="gm12-wrap">
        <ThankYouBody data={data} p="cok12" c={c} />
      </div>

      {/* FOOTER — same dark footer as the sales page */}
      <footer className="gm12-foot">
        <div className="gm12-wrap gm12-foot-in">
          <div className="cok12-foot">{c.guaranteeOn ? c.guarantee : `© ${c.brand}`}</div>
        </div>
      </footer>
    </div>
  );
}
